import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class IosHelpersService {
  private isIOS: boolean = false;

  constructor() {
    this.detectiOS();
  }

  /**
   * Detecta si el dispositivo es iOS
   */
  private detectiOS(): void {
    // Detectar iOS (incluye iPhone, iPad, iPod)
    const userAgent = window.navigator.userAgent;
    this.isIOS =
      /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;

    // También detectamos Safari en macOS, que tiene comportamientos similares
    const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
    const isMac = /Mac/.test(userAgent);

    if (this.isIOS || (isSafari && isMac)) {
      this.applyIOSFixes();
    }
  }

  /**
   * Indica si el dispositivo es iOS
   */
  public isiOSDevice(): boolean {
    return this.isIOS;
  }

  /**
   * Aplica correcciones para iOS
   */
  private applyIOSFixes(): void {
    // Añadir una clase al body para aplicar estilos específicos
    document.body.classList.add('ios-device');

    // Solucionar el problema del 100vh en iOS
    this.fixIOSViewportHeight();

    // Agregar listeners para eventos que puedan causar problemas en iOS
    this.setupTouchListeners();
  }

  /**
   * Soluciona el problema del 100vh en iOS
   */
  private fixIOSViewportHeight(): void {
    // Establecer una variable CSS personalizada con la altura de la ventana
    const setVh = () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    setVh();
    window.addEventListener('resize', setVh);
    window.addEventListener('orientationchange', setVh);
  }

  /**
   * Configura listeners para eventos de toque en iOS
   */
  private setupTouchListeners(): void {
    // Prevenir zoom en doble toque en inputs
    document.addEventListener('gesturestart', function (e) {
      e.preventDefault();
    });

    // Mejorar la respuesta al toque en modales
    document.addEventListener(
      'touchmove',
      function (e) {
        if (document.querySelector('.modal-overlay, .custom-modal-overlay')) {
          if (
            !(e.target as HTMLElement).closest(
              '.modal-content, .custom-modal-content'
            )
          ) {
            e.preventDefault();
          }
        }
      },
      { passive: false }
    );
  }

  /**
   * Aplica estilos a un elemento modal para que funcione correctamente en iOS
   * @param element Elemento DOM del modal
   */
  public fixModalForIOS(element: HTMLElement): void {
    if (!this.isIOS) return;

    // Forzar repaint/reflow
    void element.offsetHeight;

    // Aplicar estilos para forzar stacking context adecuado
    element.style.transform = 'translateZ(0)';
    element.style.willChange = 'transform';
    element.style.backfaceVisibility = 'hidden';
    element.style.zIndex = '9999';

    // Añadir clase para aplicar estilos adicionales del CSS global
    element.classList.add('ios-fixed-element');
  }

  /**
   * Mueve un elemento modal directamente al body para evitar problemas de stacking context
   * @param element Elemento DOM del modal
   */
  public moveModalToBody(element: HTMLElement): void {
    if (element.parentElement !== document.body) {
      document.body.appendChild(element);
    }
  }
}
